import { Column, CreateDateColumn, Entity, OneToOne, PrimaryColumn, UpdateDateColumn, VersionColumn } from 'typeorm';
import { PARequestChildEntity } from './pa-request-child-entity';

@Entity('production_adjustment_request_list')
export class PARequestListEntity {

    @PrimaryColumn({ type: 'varchar', length: 30, name: 'request_id' })
    requestId: string;


    @Column({ name: 'original_order_plan_number', type: 'int', nullable: false })
    originalOrderPlanNumber: number;

    @Column({ name: 'dept', type: 'int', nullable: true })
    dept: number;

    @Column({ name: 'year', type: 'int', nullable: true })
    year: number;

    @Column({ name: 'ssn', type: 'varchar', length: 30, nullable: true })
    ssn: string;

    @Column({ name: 'item_code', type: 'int', nullable: true })
    itemCode: number;

    @Column('varchar', { name: "item_name", length: 255, nullable: true })
    itemName: string;

    @Column({ name: 'bu_cd', type: 'int', nullable: true })
    buCd: number;

    @Column({ name: 'biz', type: 'varchar', length: 30, nullable: true })
    biz: string;

    @Column({ name: 'main_sample_cd', type: 'varchar', length: 30, nullable: true })
    mainSampleCd: string;

    @Column({ name: 'management_factory_cd', type: 'varchar', length: 30, nullable: true })
    managementFactoryCd: string;

    @Column({ name: 'management_factory', type: 'varchar', length: 30, nullable: true })
    managementFactory: string;

    @Column({ name: 'branch_factory_cd', type: 'varchar', length: 30, nullable: true })
    branchFactoryCd: string;

    @Column({ name: 'branch_factory', type: 'varchar', length: 30, nullable: true })
    branchFactory: string;

    @Column({ name: 'vendor_cd', type: 'int', nullable: true })
    vendorCd: number;

    @Column({ name: 'vendor', type: 'varchar', length: 30, nullable: true })
    vendor: string;

    @Column({ name: 'original_order_process_target', type: 'varchar', length: 30, nullable: true })
    originalOrderProcessTarget: string;

    @Column({ name: 'original_order_process_done', type: 'varchar', length: 30, nullable: true })
    originalOrderProcessDone: string;

    @Column({ name: 'original_ph', type: 'varchar', length: 30, nullable: true })
    originalPh: string;

    @Column({ name: 'original_publish', type: 'varchar', length: 30, nullable: true })
    originalPublish: string;

    @Column({ name: 'original_trnspt_mthd', type: 'varchar', length: 30, nullable: true })
    originalTrnsptMthd: string;

    @Column({ name: 'original_wh', type: 'varchar', length: 30, nullable: true })
    originalWh: string;

    @Column({ name: 'original_dl', type: 'varchar', length: 30, nullable: true })
    originalDl: string;

    @Column({ name: 'original_plan_qty', type: 'int', nullable: true })
    originalPlanQty: number;

    @Column({ name: 'original_update_date', type: 'varchar', length: 30, nullable: true })
    originalUpdateDate: string;


    @Column({ name: 'request_classification', type: 'varchar', length: 30, nullable: true })
    requestClassification: string;

    @Column({ name: 'request_type', type: 'varchar', length: 30, nullable: true })
    requestType: string;

    @Column({ name: 'request_color', type: 'varchar', length: 30, nullable: true })
    requestColor: string;

    @Column({ name: 'request_wh', type: 'varchar', length: 30, nullable: true })
    requestWh: string;

    @Column({ name: 'request_dl', type: 'varchar', length: 30, nullable: true })
    requestDl: string;

    @Column({ name: 'request_plan_qty', type: 'varchar', length: 30, nullable: true })
    requestPlanQty: string;

    @Column({ name: 'request_trnspt_mthd', type: 'varchar', length: 30, nullable: true })
    requestTrnsptMthd: string;

    @Column({ name: 'request_request_date_jst', type: 'varchar', length: 30, nullable: true })
    requestRequestDateJst: string;

    @Column({ name: 'request_request_user', type: 'varchar', length: 30, nullable: true })
    requestRequestUser: string;

    @Column({ name: 'request_comment', type: 'text', nullable: true })
    requestComment: string;

    @Column({ name: 'request_sales_rank_of_biz_at_last_week', type: 'varchar', length: 30, nullable: true })
    requestSalesRankOfBizAtLastWeek: string;

    @Column({ name: 'request_sales_rank_of_div_at_last_week', type: 'varchar', length: 30, nullable: true })
    requestSalesRankOfDivAtLastWeek: string;

    @Column({ name: 'answer_dl_jst', type: 'varchar', length: 30, nullable: true })
    answerDlJst: string;

    @Column({ name: 'factory_answer_agr_flg', type: 'varchar', length: 30, nullable: true })
    factoryAnswerAgrFlg: string;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    // @Column("bit", {
    //   nullable: false,
    //   name: "is_active",
    //   default:1
    // })
    // isActive: boolean;
    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;


    @Column('varchar', { name: 'company_code', length: 20, nullable: true })
    companyCode: string;

    @Column('varchar', { name: 'unit_code', length: 20, nullable: true })
    unitCode: string;


    @Column({ name: 'file_reference_id', type: 'uuid' })
    fileReferenceId: string;

    @OneToOne(() => PARequestChildEntity, (paChild) => { paChild.paRequestId }, { cascade: true })
    paRequestChildId: PARequestChildEntity;

}
